import { Outlet } from 'react-router';

const SignInLayout = () => {
  return <Outlet />;
};

export default SignInLayout;
